import { resolveLastKnownInventoryAgeLabel } from "../newThread/lastKnownInventoryAge";

/**
 * How old a stopped Environment's last-known inventory is, above the search
 * field. Renders nothing for a live inventory: there is no cutoff after
 * which models are refused, only this line saying how old the answer is.
 */
export function ModelPickerInventoryAge(props: {
  readonly lastKnownInventoryPublishedAt: string | null | undefined;
}) {
  const label = resolveLastKnownInventoryAgeLabel({
    lastKnownInventoryPublishedAt: props.lastKnownInventoryPublishedAt ?? null,
  });
  return label === null ? null : (
    <p
      className="border-b px-3 py-1.5 text-xs text-muted-foreground"
      data-testid="model-picker-inventory-age"
    >
      {label}
    </p>
  );
}
